import * as React from 'react';
import { Svg } from '../svg';

function SvgNoRatingChange({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 10 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect x={0.5} y={0.5} width={9} height={3} rx={0.5} fill="#BBC0C5" />
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgNoRatingChange);
export default ForwardRef;
